export default function Footer() {
  return (
    <footer className="site-footer">
      <p className="footer-name">Dojo of Pain &nbsp;|&nbsp; Washington D.C.</p>
      <p className="footer-made">
        Made with love in the nation's capital
        <img src="/fist_small.png" className="footer-fist" alt="" />
      </p>
    </footer>
  );
}
